import { create } from "zustand";

export interface PermissionState {
  permissions: string[];
  isLoading: boolean;
  isReady: boolean;
  error?: string;
  setPermissions: (permissions: string[]) => void;
  setLoading: (isLoading: boolean) => void;
  setReady: (isReady: boolean) => void;
  setError: (error?: string) => void;
  resetPermissions: () => void;
  hasPermission: (permission?: string) => boolean;
}

const usePermissionStore = create<PermissionState>((set, get) => ({
  permissions: [],
  isLoading: false,
  isReady: false,
  error: undefined,
  setPermissions: (permissions) =>
    set(() => ({
      permissions,
    })),
  setLoading: (isLoading) =>
    set(() => ({
      isLoading,
    })),
  setReady: (isReady) =>
    set(() => ({
      isReady,
    })),
  setError: (error) =>
    set(() => ({
      error,
    })),
  resetPermissions: () =>
    set(() => ({
      permissions: [],
      isLoading: false,
      isReady: false,
      error: undefined,
    })),
  hasPermission: (permission?: string) => {
    if (!permission) return true;
    return get().permissions.includes(permission);
  },
}));

export default usePermissionStore;
